"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.atanDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var atanDependencies = exports.atanDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createAtan: _factoriesAny.createAtan
};